/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const UserListing = loadable(() => import('./Users'), { fallback: <LoadingIndicator /> });

export const UserDetails = loadable(() => import('./UserDetails'), { fallback: <LoadingIndicator /> });
